"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Lottie = require("./Lottie");
Object.keys(_Lottie).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Lottie[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Lottie[key];
    }
  });
});